import { Component } from '@angular/core';
import { ADDITIONAL_RESOURCES, AdditionalResourceLink } from './additional-resources.config';

/**
 * Static link grid for the Flexi customer view — Appendix C of the umbrella
 * spec. No backend dependency: the catalog is defined in
 * <c>additional-resources.config.ts</c>, all labels go through the
 * `FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.*` translation namespace, and links
 * always open in a new tab with `rel="noopener"`.
 */
@Component({
  selector: 'flexi-additional-resources',
  templateUrl: './additional-resources.component.html',
  styleUrls: ['./flexi-onboarding.scss'],
  standalone: false
})
export class AdditionalResourcesComponent {
  readonly links: AdditionalResourceLink[] = ADDITIONAL_RESOURCES;

  /** Strip protocol + `www.` so the user sees the bare host in the chip. */
  hostOf(url: string): string {
    try {
      const { hostname } = new URL(url);
      return hostname.replace(/^www\./, '');
    } catch {
      return url;
    }
  }
}
